"use client";

import { usePathname } from "next/navigation";

/**
 * Top navigation bar — brand on the left, evenly-spaced nav items in
 * the middle, hamburger on the right. Hamburger dispatches the
 * `bo:open-menu` custom event which FloatingNav listens for to open
 * its existing full-screen overlay (socials + deep links + contact).
 *
 * Nav items are plain <a> tags (not next/link) so each click triggers
 * a full document load — client-side route transitions were tripping
 * the app error boundary on certain pages.
 */
const NAV_ITEMS = [
  { href: "/", label: "Burak Ozgur", brand: true },
  { href: "/about", label: "About" },
  { href: "/books", label: "Books" },
  { href: "/blog", label: "Blog" },
  { href: "/contact", label: "Contact" },
];

export default function TopNav() {
  const pathname = usePathname();

  const isActive = (href) =>
    href === "/" ? pathname === "/" : pathname?.startsWith(href);

  const openMenu = () => {
    if (typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent("bo:open-menu"));
    }
  };

  return (
    <header className="bo-topnav" role="banner">
      <nav className="bo-topnav-inner" aria-label="Primary">
        {NAV_ITEMS.map((item) => (
          <a
            key={item.href}
            href={item.href}
            className={
              "bo-topnav-item" +
              (item.brand ? " bo-topnav-brand" : "") +
              (isActive(item.href) ? " is-active" : "")
            }
          >
            <span className="bo-topnav-label">{item.label}</span>
          </a>
        ))}
        <button
          type="button"
          className="bo-topnav-hamburger"
          aria-label="Open menu"
          onClick={openMenu}
        >
          <span />
          <span />
        </button>
      </nav>
    </header>
  );
}
